/*
 * Badge
 * @module components/Badges
 * @flow
 */

import React from 'react';
import styled from 'styled-components/macro';

import { Tooltip } from '~/components';

export type BadgeProps = {
  icon: string,
  size?: number,
  tooltip: React$Node | string,
};

const BadgeIconWrapper = styled.div`
  display: inline-flex;
`;

const BadgeIcon = styled.div`
  width: ${props => props.size}px;
  height: ${props => props.size}px;
  background-image: url(${props => props.icon});
  background-size: cover;
`;

/**
 * Badge React-component
 * @memberof components
 * @param {Object} props - properties
 * @param {string} [props.icon] - icon
 * @param {number} [props.size] - size
 * @param {React$Node | string} [props.tooltip] - tooltip overlay
 * @example <caption>Simple usage</caption>
 * <Badge />
 * @returns {React.Node<*>} React-component
 */
export const Badge = ({ icon, tooltip, size }: BadgeProps) => {
  const iconComponent = <BadgeIcon icon={icon} size={size} />;

  return (
    <BadgeIconWrapper testid="badgebtc">
      {tooltip ? (
        <Tooltip
          placement="top"
          overlay={tooltip}
          overlayClassName="react-small-tooltip"
        >
          {iconComponent}
        </Tooltip>
      ) : (
        { iconComponent }
      )}
    </BadgeIconWrapper>
  );
};

Badge.defaultProps = {
  size: 42,
};
